// extracted by mini-css-extract-plugin
module.exports = {"MenuBurger":"MenuBurger_MenuBurger__orpFp","BurgerOpen":"MenuBurger_BurgerOpen__8fCWQ"};